import React from 'react';


interface ComplianceItem {
  standard: string;
  description: string;
  icon: string;
}

interface SecurityComplianceProps {
  platform: string;
  compliances: ComplianceItem[];
}

const SecurityCompliance = ({ platform, compliances }: SecurityComplianceProps) => {
  return null;
};

export default SecurityCompliance;